import { createSelector, createFeatureSelector } from "@ngrx/store";
import { CotizacionState } from "./cotizacion.reducer";

export const selectCotizacionState = createFeatureSelector<CotizacionState>('cotizacionReducer');

export const selectCotizacion = createSelector(selectCotizacionState, (state: CotizacionState) => state.data);

export const selectCotizacionResponse = createSelector(selectCotizacionState, (state: CotizacionState) => state.data ? state.data : null);